<template>
  <v-layout>
    <v-dialog 
      :modelValue="dialog" 
      @click:outside="closeDialog()" 
      @keydown.esc="closeDialog()" 
      :max-width="$vuetify.display.mdAndDown ? undefined : '1000px'"
      :fullscreen="$vuetify.display.mdAndDown"
      transition="dialog-bottom-transition"
      :scrim="!$vuetify.display.mdAndDown"
    >

      <v-card :class="$vuetify.display.mdAndDown ? 'h-100 d-flex flex-column' : ''">
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text :class="$vuetify.display.mdAndDown ? 'flex-grow-1 overflow-auto h-100' : ''">
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-0 mt-0">
              <v-col :cols="$vuetify.display.smAndDown ? 11 : 12" :md="$vuetify.display.mdAndDown ? 12 : 10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step" :direction="$vuetify.display.mdAndDown ? 'vertical' : 'horizontal'">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col :cols="$vuetify.display.smAndDown ? 11 : 12" :md="$vuetify.display.mdAndDown ? 12 : 10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <p>{{ steps[0].description }}</p>
                    <v-row>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 4">
                        <v-text-field type="date" v-model="item.date" name="date" label="Fecha*" :disabled="disabled" :rules="[rules.required]"></v-text-field>
                      </v-col>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 4">
                        <v-text-field
                          type="date"
                          v-model="item.estimated_departure_date"
                          name="estimated_departure_date"
                          label="Fecha estimada de entrega*"
                          :disabled="disabled"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 4">
                        <v-combobox
                          v-model="item.almacen"
                          name="almacen"
                          item-title="name"
                          item-value="id"
                          :items="almacenes"
                          label="Almacen*"
                          autocomplete="off"
                          :disabled="disabled"
                          :rules="[rules.requiredComboBox]"
                          clearable
                        ></v-combobox>
                      </v-col>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 6">
                        <v-combobox
                          v-model="item.document_type"
                          name="document_type"
                          item-title="name"
                          item-value="id"
                          :items="documents_types"
                          label="Tipo de Documento*"
                          autocomplete="off"
                          :disabled="disabled"
                          :rules="[rules.requiredComboBox]"
                          clearable
                        ></v-combobox>
                      </v-col>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 6">
                        <v-combobox
                          v-model="item.canal_venta"
                          name="canal_venta"
                          item-title="name"
                          item-value="id"
                          :items="canales_venta"
                          label="Canal de Venta"
                          autocomplete="off"
                          :disabled="disabled"
                          :rules="[rules.onlySelectFromList]"
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 6" v-if="!isClient">
                        <v-combobox
                          v-model="item.client"
                          name="client"
                          item-title="name"
                          item-value="id"
                          :items="clients"
                          label="Cliente*"
                          autocomplete="off"
                          :disabled="disabled"
                          :rules="[rules.requiredComboBox]"
                          clearable
                        ></v-combobox>
                      </v-col>
                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 6">
                        <v-text-field label="Referencia Externa" v-model="item.external_reference" :disabled="disabled"></v-text-field>
                      </v-col>

                      <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 12">
                        <v-textarea label="Observaciones" v-model="item.observaciones" :disabled="disabled" rows="3"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                  <div :class="$vuetify.display.mdAndDown ? 'd-flex justify-space-between mt-4' : ''">
                    <div v-if="$vuetify.display.mdAndDown"></div>
                    <v-btn 
                      :class="$vuetify.display.mdAndDown ? '' : 'float-right'" 
                      class="btn-second" 
                      v-if="step < steps.length - 1" 
                      @click="next"
                    >
                      Siguiente
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <!--step 1-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col :cols="$vuetify.display.smAndDown ? 11 : 12" :md="$vuetify.display.mdAndDown ? 12 : 10" class="mt-4 pr-0 pl-0">
                  <div class="px-2 py-1 mb-3 bg-subtitle-section">
                    <p class="text-subtitle-1 mb-0">
                      <b>{{ steps[1].title }}</b>
                    </p>
                  </div>
                  <p>{{ steps[1].description }}</p>

                  <FormDestino :open="dialog" :shipment_order="item" :step="step" :steps="steps" :disabled="disabled" @prev="prev" @next="next" @updateShipmentOrderItem="updateShipmentOrderItem" />
                </v-col>
              </v-row>

              <!--step 2-->
              <v-row align="start" justify="center" v-if="step == 2" transition="fade-transition">
                <v-col :cols="$vuetify.display.smAndDown ? 11 : 12" :md="$vuetify.display.mdAndDown ? 12 : 10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step2">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[2].title }}</b>
                      </p>
                    </div>
                    <p>{{ steps[2].description }}</p>

                    <TablePresentations :shipment_order="item" :open="dialog" :step="step" :steps="steps" :isViewModal="disabled"  @addProduct="addProduct" @removeProduct="removeProduct" />

                    <div :class="$vuetify.display.mdAndDown ? 'd-flex justify-space-between mt-4' : ''">
                      <v-btn 
                        v-if="step > 0" 
                        @click="prev" 
                        :class="$vuetify.display.mdAndDown ? '' : 'mt-5'" 
                        color="blue-grey"
                      >
                        Atras
                      </v-btn>
                      <v-btn 
                        :class="$vuetify.display.mdAndDown ? '' : 'float-right mt-5'" 
                        class="btn-second" 
                        v-if="step < steps.length - 1" 
                        @click="next"
                      >
                        Siguiente
                      </v-btn>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions class="pa-4" :class="$vuetify.display.mdAndDown ? 'flex-shrink-0' : ''">
            <v-spacer></v-spacer>
            <v-btn color="error" :variant="$vuetify.display.mdAndDown ? 'text' : 'text'" @click="closeDialog()">
              Cerrar
            </v-btn>
            <v-btn 
              color="success" 
              :variant="'text'" 
              type="submit" 
              :loading="loading" 
              v-if="!disabled && step == 2"
              :class="$vuetify.display.mdAndDown ? 'px-6 ml-3' : ''"
            >
              {{ formBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import { documentsTypeService } from "@/libs/ws/documentsTypeService";
import { canalesVentasService } from "@/libs/ws/canalesVentasService";
import UserTypeConstant from "@/constants/user_type";

import ValidMixin from "@/mixins/ValidMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import TablePresentations from "./TablePresentations.vue";
import FormDestino from "./FormDestino.vue";
import { it } from "vuetify/lib/locale";

export default {
  components: { TablePresentations, FormDestino },
  mixins: [ValidMixin, AliasMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
    isClient: Boolean
  },
  data() {
    return {
      disabled: false,
      clients: [],
      almacenes: [],
      canales_venta: [],
      documents_types: [],
      loading: false,
      step: 0,
      steps: [
        {
          title: "Datos Generales",
          description: "Complete los datos generales del pedido",
          content: "First-content",
        },
        {
          title: "Información de Destino",
          description: "Complete la información de destino del pedido",
          content: "Second-content",
        },
        {
          title: "Detalle Pedido",
          description: "Ingrese el detalle del pedido",
          content: "Third-content",
        },
      ],
      item: {
        //cabecera
        id: "",
        document_type: null,
        client: null,
        sub_client: null,
        almacen: null,
        external_reference: "",
        estimated_departure_date: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        //destino
        receiver: "",
        address: "",
        location: "",
        postal_code: "",
        provincia: null,
        canal_venta:null,
        observaciones: "",
          lat: null, 
          lng: null,
        // detalle
        items: [],
      },
      defaultItem: null,
      user_type: null,
      userTypeConstant: UserTypeConstant,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.loadCombobox();
        this.disabled = this.formBtn == "";
        this.step = 0;
        if (this.$refs.form_step0) {
          this.$refs.form_step0.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
        } else {
          if (this.defaultItem != null) this.item = JSON.parse(JSON.stringify(this.defaultItem));
        }
      }
    },
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.item.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.loadCombobox();
  },
  methods: {
    closeDialog() {
      this.$emit("updateDialog", false);
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
    },
    updateShipmentOrderItem(updatedProperties) {
      this.item = {
        ...this.item, // Copiamos las propiedades existentes
        ...updatedProperties, // Sobrescribimos o añadimos las nuevas propiedades
      };
    },
    prev() {
      this.step--;
    },
    async next() {
      let valid;

      switch (this.step) {
        case 0: {
          ({ valid } = await this.$refs.form_step0.validate());
          break;
        }
        case 1: {
          valid = true;
          break;
        }
        case 2: {
          valid = true;
          break;
        }
        default: {
          valid = false;
          break;
        }
      }

      if (valid) {
        this.step++;
        if (this.$refs.form_step1) {
          this.$refs.form_step1.resetValidation();
        }
      } else {
        this.toast.error("Complete los campos obligatorios");
        //console.log("errors", this.$refs.form_step0.errors);
      }
    },
    loadCombobox() {
      this.loadAlmacenes();
      this.loadClientes();
      this.loadDocumentTypes();
      this.loadCanalesVentas();
      this.defaultItem = JSON.parse(JSON.stringify(this.item));
    },
    comboCategoryChange(event) {
      this.loadSubcategorias();
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadCanalesVentas() {
      canalesVentasService
        .filter({})
        .then((response) => {
          this.canales_venta = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadDocumentTypes() {
      documentsTypeService
        .filter({ order_type: "OUT" })
        .then((response) => {
          this.documents_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    addProduct(item, index = -1) {
      if (index == -1) this.item.items.push(item);
      else this.item.items[index] = item;
    },
    removeProduct(index) {
      this.item.items.splice(index, 1);
    },
    async createItem() {
      if (this.loading) return;
      const { valid } = await this.$refs.form_step2.validate();
      //TODO: Verificar que haya items

      if (valid) {
        this.loading = true;

        var data = JSON.parse(JSON.stringify(this.item));
        data.items_arr = data.items;
        delete data.items;

        //Antes de mandar hay que recorrer los items y setear: lote, serie
        data.items_arr.forEach((item, index) => {
          if(item.lote != null && item.lote != undefined && item.lote?.id != null){
            data.items_arr[index].lote = item.lote.id;
          }

          if(item.serie != null && item.serie != undefined && item.serie?.id != null){
            data.items_arr[index].serie = item.serie.id;
          }

          if(item.descriptivo_3 != null && item.descriptivo_3 != undefined && item.descriptivo_3?.id != null){
            data.items_arr[index].descriptivo_3 = item.descriptivo_3.id;
          }
        });

        if (this.item.id > 0) {
          this.service
            .update(data)
            .then((response) => {
              if (response.status) {                
                this.toast.success("El " + this.modal_title + " se modifico correctamente.");                
                this.closeDialog();
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.service
            .create(data)
            .then((response) => {
              if (response.status) {
                //this.toast.success("El " + this.modal_title + " se creo correctamente");
                this.toast.success(response.msg);//Para mostrar el mensaje de reserva segun cannal de venta
                this.closeDialog();
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      } else {
        console.log("errors2", this.$refs.form_step2.errors);
        this.toast.error("Complete los campos obligatorios");
      }
    },
  },
};
</script>
